export const CONFIG_ENVIRONMENT_VALUES = ['production', 'sandbox'] as const;
export const CONFIG_LANGUAGE_VALUES = ['en', 'pt', 'es'] as const;

type APEnvironment = (typeof CONFIG_ENVIRONMENT_VALUES)[number];

type APAvailableLanguages = (typeof CONFIG_LANGUAGE_VALUES)[number];

export type APCore = {
  environment?: APEnvironment;
  language?: APAvailableLanguages;
  tracking?: boolean;
};
